import { useContext, useEffect, useState } from 'react';
import { MarketContext } from 'context/market';
import { useParams } from 'next/navigation';
import Spinner from '../spinner';

const MarketToggle = () => {
  const { market: selectedMarket, markets, handleMarket } = useContext(MarketContext);
  const { locale } = useParams();

  useEffect(() => {
    // Set locale session cookie
    document.cookie = `locale=${locale}; path=/`;
  }, [locale]);

  // Spinner state
  const [loading, setLoading] = useState(false);

  // Toggle function to switch between two countries
  const toggleMarket = () => {
    setLoading(true);

    // Determine the next market to switch to
    const nextMarket = markets.find((market) => market.region !== selectedMarket.region);

    if (nextMarket) {
      // Set "do not show geo website mismatch popup" cookie
      document.cookie = 'geo-location-and-website-mismatch-popup-displayed=yes; path=/';
      handleMarket(nextMarket);
    }

    // Simulate a delay to show the spinner (for demonstration purposes)
  };

  return (
    <div className="flex items-center justify-center">
      {loading && <Spinner />} {/* Show spinner if loading */}
      {selectedMarket && (
        <div className="toggle-container" onClick={toggleMarket}>
          <div className={`toggle-button ${selectedMarket.region === markets[0].region ? 'off' : 'on'}`}>
            <span className="toggle-market-text-left">{markets[0].flag}</span>
            <div className="toggle-circle">
              <span className="toggle-market-text-circle">{selectedMarket.flag}</span>
            </div>
            <span className="toggle-market-text-right">{markets[1].flag}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default MarketToggle;
